import { styled } from "styled-components";
import { smallMediaBreakpoint, spacingS } from "@RooUI";

export const ImprovedFiltersGroupWrapper = styled.div`
  width: 544px;

  & > div {
    & > div {
      gap: ${spacingS} !important;
      margin-top: 6px;
    }
  }

  @media (max-width: ${smallMediaBreakpoint}) {
    width: 264px;
  }
`;

export const StyledGroupWrapper = styled.div`
  & > div {
    & > div {
      gap: 0 !important;
    }
  }
`;

export const SingleColumnCheckboxGroups = styled.div`
  & > div {
    & > div {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      row-gap: ${spacingS};
    }
  }
`;
